/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _slicedToArray } from '../_chunks/dep-e43cf21c.js';
import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import MessageClose from './MessageClose.js';
import MessageIcon from './MessageIcon.js';
import { useMessageClass } from './useMessageClass.js';
import { usePersistFn } from '../_util/usePersistFn.js';
import noop from '../_util/noop.js';
import '../_chunks/dep-2acfafca.js';
import 'tdesign-icons-react';
import '../hooks/useGlobalIcon.js';
import '../hooks/useConfig.js';
import '../config-provider/ConfigContext.js';
import '../_chunks/dep-46de7b2e.js';
import '../_chunks/dep-d71ee5f3.js';
import '../_chunks/dep-c3f1141e.js';
import '../_chunks/dep-4b8f240e.js';
import '../_chunks/dep-9acbc163.js';
import '../_chunks/dep-7b52f080.js';
import '../_chunks/dep-f10515e8.js';
import '../_chunks/dep-4941ebe7.js';
import '../_chunks/dep-e9b62d1f.js';
import '../_chunks/dep-88cd50bf.js';
import '../_chunks/dep-dcb5aa2a.js';
import '../_chunks/dep-ee4bf8c2.js';
import '../_chunks/dep-934eda0c.js';
import '../_chunks/dep-7dce2c26.js';
import '../_chunks/dep-12510d64.js';
import '../_chunks/dep-6b568d83.js';
import '../_chunks/dep-304e657b.js';
import '../_chunks/dep-77e34309.js';
import '../_chunks/dep-6506fbc2.js';
import '../_chunks/dep-bb5d7b1e.js';
import '../_chunks/dep-e285f2f8.js';
import '../_chunks/dep-f4a320cd.js';
import '../_chunks/dep-ec70b95c.js';
import '../locale/zh_CN.js';
import '../_common/js/global-config/locale/zh_CN.js';
import 'dayjs';
import '../_chunks/dep-cbcc9f89.js';
import '../_common/js/global-config/default-config.js';
import '../loading/index.js';
import '../loading/Loading.js';
import '../_util/dom.js';
import 'raf';
import '../_chunks/dep-6c5254c6.js';
import '../_util/easing.js';
import '../common/Portal.js';
import 'react-dom';
import '../loading/gradient.js';
import '../hooks/useDomRefCallback.js';
import '../_common/js/loading/circle-adapter.js';
import '../_common/js/utils/set-style.js';
import '../_common/js/utils/helper.js';
import '../_chunks/dep-fd3498b6.js';
import '../_chunks/dep-92728dc5.js';
import '../_chunks/dep-ec16db36.js';
import '../_chunks/dep-036ad2cc.js';
import '../_chunks/dep-0e15088f.js';
import '../loading/defaultProps.js';
import '../loading/plugin.js';
import '../_util/react-render.js';
import '../_chunks/dep-e0370ebe.js';
import '../loading/style/css.js';
import '../loading/type.js';

var MessageComponent = function MessageComponent(props) {
  var _useMessageClass = useMessageClass(),
    tdMessagePrefix = _useMessageClass.tdMessagePrefix,
    tdClassIsGenerator = _useMessageClass.tdClassIsGenerator;
  var _props$theme = props.theme,
    theme = _props$theme === void 0 ? "info" : _props$theme,
    className = props.className,
    children = props.children,
    style = props.style,
    _props$icon = props.icon,
    icon = _props$icon === void 0 ? true : _props$icon,
    content = props.content,
    closeBtn = props.closeBtn,
    _props$onCloseBtnClic = props.onCloseBtnClick,
    onCloseBtnClick = _props$onCloseBtnClic === void 0 ? noop : _props$onCloseBtnClic,
    _props$onDurationEnd = props.onDurationEnd,
    onDurationEnd = _props$onDurationEnd === void 0 ? noop : _props$onDurationEnd,
    _props$onClose = props.onClose,
    onClose = _props$onClose === void 0 ? noop : _props$onClose,
    duration = props.duration;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isHovering = _useState2[0],
    setIsHovering = _useState2[1];
  var onCloseFn = usePersistFn(onClose);
  var onDurationEndFn = usePersistFn(onDurationEnd);
  var onCloseBtnClickFn = usePersistFn(onCloseBtnClick);
  function handleCloseBtnClick(e) {
    onCloseBtnClickFn(e);
    onCloseFn({
      trigger: "close-click"
    });
  }
  useEffect(function () {
    if (!isHovering && duration > 0) {
      var timer = setTimeout(function () {
        onDurationEndFn();
        onCloseFn({
          trigger: "duration-end"
        });
      }, duration);
      return function () {
        clearTimeout(timer);
      };
    }
  }, [duration, isHovering, onCloseFn, onDurationEndFn]);
  return /* @__PURE__ */React.createElement("div", {
    key: "message",
    style: style,
    className: classNames(className, "".concat(tdMessagePrefix), tdClassIsGenerator(theme), closeBtn ? tdClassIsGenerator("closable") : ""),
    onMouseEnter: function onMouseEnter() {
      return setIsHovering(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setIsHovering(false);
    }
  }, icon === true ? /* @__PURE__ */React.createElement(MessageIcon, {
    theme: theme
  }) : icon, content ? content : children, /* @__PURE__ */React.createElement(MessageClose, {
    closeBtn: closeBtn,
    onCloseBtnClick: handleCloseBtnClick
  }));
};

export { MessageComponent as default };
//# sourceMappingURL=MessageComponent.js.map
